import { Quote } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const RESULTS = [
  {
    metric: "111 MPH",
    metricLabel: "Exit Velo — Facility Record",
    quote:
      "Unreal day of hitting. Broke the facility record, which was 110, and got 111. Hardest I've ever hit a ball. Thank you bro.",
    name: "Caleb V.",
    role: "1-On-1 Athlete",
  },
  {
    metric: "4 DOUBLES",
    metricLabel: "In 2 Games — HS Season Was 23 Singles",
    quote:
      "I'm already seeing progress in my bat speed and my ability to rotate and power. In high school I had 23 hits, all singles — since starting this program I've had 4 doubles in 2 games.",
    name: "Kyan M.",
    role: "1-On-1 Athlete",
  },
  {
    metric: "105→108",
    metricLabel: "MPH — Summer PR",
    quote:
      "I've been hovering around 105 all summer — finally got up to 108.",
    name: "Giovanni T.",
    role: "1-On-1 Athlete",
  },
  {
    metric: "100s ×5",
    metricLabel: "DB Bench — 2 Sets",
    quote:
      "Got 100s for DB bench for 2 sets of 5. Last week I only got 100 on the last set for 3. LFG.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "+5 LB",
    metricLabel: "Size Gained",
    quote:
      "This workout is helping so much, I can't thank you enough. I've already gained 5 pounds and my family has noticed I've been getting bigger.",
    name: "Nick H.",
    role: "1-On-1 Athlete",
  },
  {
    metric: "HARDER + FARTHER",
    metricLabel: "Strength Showing Up",
    quote:
      "Man, I really feel the strength coming. Reps are getting easier and I definitely feel a lot stronger — hitting the ball harder and farther.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "EVERY WEEK",
    metricLabel: "Weights Going Up",
    quote:
      "Going really good — weights jumping up each week. I love how easy it is to track everything; your previous workouts are right there so you can push yourself to go heavier every week.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "DOUBLE + TRIPLE",
    metricLabel: "One Tournament Weekend",
    quote:
      "Outstanding — had a double in the gap and a triple down the line yesterday. I've been moving up in weight every week and seeing a lot of improvement.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "MUCH MORE POP",
    metricLabel: "Transferring To His Swing",
    quote:
      "The plan is going great — I've progressed on all my lifts and I see it transferring when I hit. I have much more pop than before.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "CRAZY EXPLOSIVE",
    metricLabel: "Lifts & Weights",
    quote:
      "I'm already feeling crazy explosive with my lifts and weights.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "FEEL STRONGER",
    metricLabel: "After A Couple Sessions",
    quote:
      "I know it's only been a couple of sessions but my legs do actually feel stronger.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
  {
    metric: "CHANGED ME",
    metricLabel: "His Words, Not Ours",
    quote:
      "Dude, this program has changed me so much I can't thank you enough.",
    name: "Coaching Athlete",
    role: "1-On-1 Athlete — Name Kept Private",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-[#141416]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader index="05" label="Athlete Results" title="Proof Over Promises" />
        <Reveal delay={0.1}>
          <p className="max-w-2xl text-sm text-zinc-500 font-mono2 uppercase tracking-[0.15em] mb-14">
            Real words from real athletes — more added as the roster grows
          </p>
        </Reveal>
        <div className="grid gap-5 sm:gap-6 md:grid-cols-3">
          {RESULTS.map((r, i) => (
            <Reveal key={i} delay={0.1 + i * 0.12} className="h-full">
              <div
                className="h-full flex flex-col bg-[#0B0B0C] border border-zinc-800 p-7 sm:p-9 hover:border-[#CCFF00]/40 transition-colors duration-300"
                data-testid={`testimonial-card-${i}`}
              >
                <p className="font-display text-5xl sm:text-6xl text-[#CCFF00] leading-none">
                  {r.metric}
                </p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono2 mt-2 mb-8">
                  {r.metricLabel}
                </p>
                <Quote className="w-5 h-5 text-zinc-700 mb-4" />
                <p className="text-sm text-zinc-300 leading-relaxed flex-1">{r.quote}</p>
                <div className="mt-8 pt-5 border-t border-zinc-800">
                  <p className="text-xs uppercase tracking-[0.2em] text-white font-mono2">
                    {r.name}
                  </p>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-mono2 mt-1">
                    {r.role}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
